import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '../core/theming';

import Div from './Div';

const Content = ({ mini, theme, children, contentStyle }) => (
  <Div
    pos="relative"
    minH={`calc(100vh - ${theme.application.headerHeight})`}
    m={{ l: mini ? theme.application.miniMenuWidth : theme.application.menuWidth }}
    transition={theme.application.menuTransition}
    overflow="auto"
    {...contentStyle}
  >
    {children}
  </Div>
);

Content.propTypes = {
  theme: PropTypes.shape({
    application: {},
  }).isRequired,
  contentStyle: PropTypes.shape({}).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  mini: PropTypes.bool,
};

Content.defaultProps = {
  children: null,
  mini: false,
};

export default withTheme(Content);
